<template>
  <div
    :class="[
      'car-info',
      { 'car-info_reverse' : reverse }
    ]"
  >
    <div
      :class="[
        'car-info__image-wrapper',
        { 'car-info__image-wrapper_reverse' : reverse },
        { 'car-info__image-wrapper_blank' : !image.src }
      ]"
    >
      <img
        v-if="image.src && image.alt"
        :src="image.src"
        :alt="image.alt"
        class="car-info__image"
        @mouseover="toggleHover(true)"
        @mouseleave="toggleHover(false)"
      >
      <Blank v-else />
    </div>
    <div
      :class="[
        'car-info__label-wrapper',
        { 'car-info__label-wrapper_reverse' : reverse }
      ]"
    >
      <h1
        v-if="($route.name === 'tech-map' || $route.name === 'service-request')"
        class="car-info__title"
      >
        {{ title }}
      </h1>
      <h2
        v-if="$route.name === 'tech-map' || $route.name === 'service-request'"
        :class="[
          'car-info__model',
          { 'h1' : isMobile }
        ]"
      >
        {{ name }}
      </h2>
      <span
        v-else
        class="car-info__name h4"
      >
        {{ name }}
      </span>
      <span
        v-if="carYear"
        class="car-info__year h4"
      >
        {{ carYear }}
      </span>
      <span
        v-if="carDriveType"
        class="car-info__drive-type h4"
      >
        {{ carDriveType }}
      </span>
      <span
        v-if="carAdditionalOption && carAdditionalOption !== '-'"
        class="car-info__additional h4"
      >
        {{ carAdditionalOption }}
      </span>

      <br v-if="$route.name !== 'tech-map' && $route.name !== 'service-request'">
      <span
        v-if="fuelType"
        class="car-info__fuel-type support-text"
      >
        {{ fuelType }}
      </span>
      <span
        v-if="volumeType"
        class="car-info__volume-type support-text"
      >
        {{ volumeType }}
      </span>
      <span
        v-if="modificationSupport"
        class="car-info__modification support-text"
      >
        {{ modificationSupport }}
      </span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { get } from 'lodash'
  import Blank from '@/assets/img/icons/blank.svg?inline'

  export default {
    name: 'CarInfo',

    components: {
      Blank
    },

    props: {
      image: {
        type: Object,
        required: true,
        validator (image) {
          return 'src' in image &&
            'alt' in image
        }
      },
      name: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      modification: {
        type: [Object, String],
        required: false
      },
      modificationSupport: {
        type: String,
        default: ''
      },
      fuelType: {
        type: String,
        default: ''
      },
      volumeType: {
        type: String,
        default: ''
      },
      reverse: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters(['isMobile']),
      carYear () {
        return get(this.modification, 'year.text')
      },
      carDriveType () {
        return get(this.modification, 'driveType.text')
      },
      carAdditionalOption () {
        return get(this.modification, 'additionalOption.value')
      }
    },

    methods: {
      toggleHover (value) {
        this.$emit('imageEnterLeave', value)
      }
    }
  }
</script>

<style lang="scss">
  .car-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 540px;

    @include tablet {
      width: 100%;
      margin: {
        bottom: 60px;
      };
    }

    @include mobile {
      margin-bottom: 30px;
    }

    &_reverse {
      flex-direction: row-reverse;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 21px;

      @include tablet {
        flex-direction: column-reverse;
      }

      @include mobile {
        margin-bottom: 40px;
      }
    }

    &__name {
      text-transform: none;
    }

    &__image {
      width: 100%;
      height: 100%;

      @include object-fit();

      &-wrapper {
        width: 540px;
        height: 265px;
        margin: {
          bottom: 30px;
        };

        @include tablet {
          width: 100%;
          height: 333px;
          margin: {
            bottom: 40px;
          };
        }

        @include mobile {
          width: 100%;
          height: 157px;
          margin: 0 auto;
          margin-bottom: 30px;
        }

        &_reverse {
          width: 100%;
          min-width: 594px;
          max-width: 594px;
          height: 281px;
          transform: rotate3d(0, 1, 0, 180deg);
          margin: {
            // right: 75px;
            bottom: 0;
          };

          @include tablet {
            margin: 55px auto 0;
          }

          @include mobile {
            width: 320px;
            min-width: 320px;
            max-width: 320px;
            height: 157px;
            margin: 40px auto 0;
          }

          @media screen and(max-width: 359px) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
          }
        }

        &_blank {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    &__label-wrapper {
      width: 100%;
      border-top: 1px solid $c-black;
      padding: {
        top: 30px;
      }

      @include mobile {
        padding: {
          top: 15px;
        }
      }

      &_reverse {
        width: auto;
        padding: 0;
        border-top: none;

        .car-info__model {
          margin-bottom: 10px;
          text-transform: none;

          @include tablet {
            margin-bottom: 15px;
          }

          @include mobile {
            margin-bottom: 13px;
          }
        }

        .car-info__modification {
          font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
          color: rgba($c-black, 0.6);

          @include mobile {
            font-size: 15px;
            line-height: 21px;
          }
        }
      }
    }

    &__title {
      font-family: "FavoritC", Arial, Helvetica, sans-serif;
      font-size: 40px !important;
      font-weight: 400 !important;
      line-height: 63px !important;
      text-transform: uppercase;
      letter-spacing: 0.08px;

      @include mobile {
        font-size: 28px !important;
        line-height: 40px !important;
      }
    }

    &__fuel-type,
    &__volume-type {
      margin-top: 5px;
      color: rgba($c-black, 0.6);

      @include mobile {
        font-size: 15px;
        line-height: 21px;
      }
    }
  }
</style>
